import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '@/components/atoms/Text/Text';
import Section from '@/components/molecules/Section/Section';
import EmailLink from '@/components/atoms/EmailLink/EmailLink';

const PrivacyContent: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <Text variant="title" className="mb-2">{t('termsAndPrivacyModal.privacy.title')}</Text>
        <Text variant="caption">{t('termsAndPrivacyModal.privacy.effectiveDate')}</Text>
      </div>
  
      <div className="space-y-4">
        <Section number="1" title={t('termsAndPrivacyModal.privacy.sections.collect.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.privacy.sections.collect.content')}
        </Section>
        
        <Section number="2" title={t('termsAndPrivacyModal.privacy.sections.use.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.privacy.sections.use.content')}
        </Section>
        
        <Section number="3" title={t('termsAndPrivacyModal.privacy.sections.sharing.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.privacy.sections.sharing.content')}
        </Section>
        
        <Section number="4" title={t('termsAndPrivacyModal.privacy.sections.security.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.privacy.sections.security.content')}
        </Section>
        
        <Section number="5" title={t('termsAndPrivacyModal.privacy.sections.rights.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.privacy.sections.rights.content')}{' '}
          <EmailLink email="privacy@aretiholdings.io" />
        </Section>
        
        <Section number="6" title={t('termsAndPrivacyModal.privacy.sections.cookies.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.privacy.sections.cookies.content')}
        </Section>
        
        <Section number="7" title={t('termsAndPrivacyModal.privacy.sections.children.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.privacy.sections.children.content')}
        </Section>
        
        <Section number="8" title={t('termsAndPrivacyModal.privacy.sections.policyChanges.title')} badgeVariant="secondary">
          {t('termsAndPrivacyModal.privacy.sections.policyChanges.content')}
        </Section>
      </div>
    </div>
  );
};

export default PrivacyContent;